import {
  Alert,
  Box,
  Button,
  Checkbox,
  CircularProgress,
  FormControlLabel,
  Snackbar,
  Stack,
  TextField,
} from "@mui/material";
import { useEffect, useRef, useState } from "react";
import { updateDepartment } from "../DepartmentServices";
import ColoredButton from "app/shared-components/ColoredButton";

export default function DepartmentUpdate({
  department,
  setRefreshDepartements,
}) {
  const [loading, setLoading] = useState();
  const [openSnackBar, setOpenSnackBar] = useState(false);
  const codeRef = useRef();
  const nameRef = useRef();
  useEffect(() => {
    codeRef.current = department.code;
    nameRef.current = department.name;
  }, []);
  function handleChangeDepartment() {
    setLoading(true);
    updateDepartment(department.id, codeRef.current, nameRef.current)
      .then(() => {
        setOpenSnackBar(true);
        setRefreshDepartements((prev) => !prev);
      })
      .finally(() => setLoading(false));
  }

  return (
    <>
      <Box className="flex flex-col gap-8 m-8">
        <Box className="flex flex-col gap-8">
          <TextField
            ref={codeRef}
            id="outlined-basic"
            label="Code"
            variant="outlined"
            defaultValue={department.code}
            onChange={(e) => (codeRef.current = e.target.value)}
          />
          <TextField
            ref={nameRef}
            id="outlined-basic"
            label="Nom"
            variant="outlined"
            defaultValue={department.name}
            onChange={(e) => (nameRef.current = e.target.value)}
          />
        </Box>
        {!loading && (
          <ColoredButton text="Valider" callback={handleChangeDepartment} />
        )}
      </Box>

      {loading && <CircularProgress />}
      <Stack spacing={2} sx={{ width: "100%" }}>
        <Snackbar
          open={openSnackBar}
          autoHideDuration={6000}
          onClose={() => setOpenSnackBar(false)}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
        >
          <Alert
            onClose={() => setOpenSnackBar(false)}
            severity="success"
            sx={{ width: "100%" }}
          >
            Département modifié avec succés!
          </Alert>
        </Snackbar>
      </Stack>
    </>
  );
}
